<script lang="ts">
	import { onMount } from 'svelte';
	import { isUserLogged, userManager } from '../../stores';
	import graphQLClient, { queryMe } from '../../graphql/client';
	import { ApolloQueryResult, gql } from 'apollo-boost';
	import { getClient, query } from 'svelte-apollo';
	import { userClientData } from '../../stores';

	function checkGraphQLErrors(errorArray: any[]) {
		if (Array.isArray(errorArray)) {
			errorArray.forEach((error) => {
				if (error.message === 'Signature verification failed') {
					console.log('Logging off because of:', error.message);
					userManager.logOff();
				}
			});
		} else {
			console.warn('errorArray is not an array', errorArray);
		}
	}

	const client = getClient();
	const meQuery = gql(queryMe);
	const meQueryOp = query(client, { query: meQuery });
	let lastUserId = typeof $userClientData.client !== 'undefined' ? $userClientData.client.id : null;

	onMount(() => {
		graphQLClient.addOnErrorListener(checkGraphQLErrors);

		if ($isUserLogged) {
			userManager.refreshProfile();
		}

		setInterval(() => {
			meQueryOp.refetch();
			meQueryOp.subscribe(async (promise) => {
				await (promise as Promise<ApolloQueryResult<any>>).then((data) => {
					if (lastUserId !== data.data.me.client.id) {
						window.location.reload();
					}
				});
			});
		}, 5000);
	});
</script>

{#if $isUserLogged}
	<slot />
{/if}

{#if !$isUserLogged}
	<slot name="notlogged" />
{/if}
